<template>
  <div class="auth-callback">
    <b-spinner label="Signing in..."></b-spinner>
    <p class="auth-callback--text">Signing in...</p>
  </div>
</template>

<script>
import swal from "sweetalert2";
import Repository from "../../services/repositories/repositoryFactory";

const AuthRepository = Repository.service("auth");

export default {
  name: "AuthCallback",
  async created() {
    const { code } = this.$route.query;
    if (!code) {
      this.fail("The sign in could not be completed, please try again. (missing code)");
      return;
    }
    let step = "session";
    try {
      // One-time code (valid a few seconds) -> our own session token
      const session = await AuthRepository.createSession(code);
      step = "me";
      // 403 here means: we know who you are, but you have no access to this app
      const me = await AuthRepository.getMe(session.access_token);
      // The whole panel works per company: a user without company/role
      // (e.g. just created by SSO) has nothing to show yet
      if (!me.role || !me.company_info?.length) {
        this.fail(
          "Your account has no company or role assigned yet. Contact an administrator.",
        );
        return;
      }
      localStorage.setItem("user-access-token", session.access_token);
      localStorage.setItem("user-info", JSON.stringify(me));
      this.$router.replace({ path: "/admin" });
    } catch (error) {
      const status = error?.response?.status;
      const detail = error?.response?.data?.detail || error?.message;
      // eslint-disable-next-line no-console
      console.error(`SSO ${step} failed`, status, detail);
      if (status === 403) {
        // Pending (no company/role yet) or inactive user: the backend says which
        this.fail(detail || "You don't have access to this application. Contact an administrator.");
      } else {
        this.fail(
          `The sign in could not be completed, please try again. (${step}: ${status || "network error"} ${detail || ""})`,
        );
      }
    }
  },
  methods: {
    fail(text) {
      localStorage.clear();
      swal
        .fire({
          title: "Sign in failed",
          text,
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#e53935",
          allowOutsideClick: false,
        })
        .then(() => this.$router.replace({ name: "Login" }));
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-callback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: $view-height;
  &--text {
    margin-top: 1rem;
  }
}
</style>
